import React, { useRef, useEffect, useState } from "react";
import { Typography, Box, Grid, Grow, Button } from '@mui/material';
import Navbar from "../components/Navbar";
import Fade from '@mui/material/Fade';
import Slide from '@mui/material/Slide';
import ArrowIcon from '../components/ArrowIcon';

function App() {
  const [checked, setChecked] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const contentRef = useRef(null);
  const content3Ref = useRef(null);
  const containerRef = useRef(null);

  const scrollToContent = () => {
    const content2 = document.getElementById('content2');
    if (content2) {
      content2.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const contentPosition = contentRef.current.getBoundingClientRect().top;
      const content3Position = content3Ref.current.getBoundingClientRect().top;
      const screenHeight = window.innerHeight;

      if (contentPosition < screenHeight - 100) {
        setChecked(true);
      }

      if (content3Position < screenHeight - 100) {
        setChecked2(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Box sx={{ width: '100%', margin: 0, padding: 0,display:'flex',flexDirection:'column' }}>
      <Box ref={containerRef} sx={{ height: {lg:'100 vh',xs:'100vh'}, margin: 0, padding: 0 }}>
        <Fade in={true} timeout={2000}>
          <Box>
            <Navbar />
          </Box>
        </Fade>
        <video autoPlay loop muted
          style={{ position: 'absolute', width: '100%',height:'100vh', objectFit: 'cover', zIndex: -1 }}>
          <source src={`./././video.mp4`} type="video/mp4" />
        </video>
        <Slide container={containerRef.current} in={true} timeout={500} direction='up'>
          <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <img src={`./././logorocs.png`} alt="Logo" style={{ width: '60vh', height: 'auto', maxWidth: '80%' }} />
            <Button onClick={scrollToContent} sx={{
              backgroundColor: '#96013C',
              padding: '10px 30px',
              borderRadius: '20px',
              fontWeight: 'bold',
              color: 'white',
              '&:hover': {
                backgroundColor: '#96013C',
              },
            }}>
              DECOUVRIR
            </Button>
            <ArrowIcon sx={{ color: 'white' }} />
          </Box>
        </Slide>
      </Box>
      <Box
        id="content2"
        ref={contentRef}
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'center',
          alignItems: 'center',
          padding: 0,
          overflow: 'hidden',
          backgroundColor: 'rgba(58, 29, 29, 0.1)',
          backgroundImage: `
            repeating-linear-gradient(to right,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0) calc(50% - 1px),
              #FFFFFF calc(50% - 1px), #FFFFFF calc(50% + 1px),
              rgba(0, 0, 0, 0) calc(50% + 1px), rgba(0, 0, 0, 0) 100%
            )
          `,
          backgroundSize: 'calc(100% / 5) 100%'
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '3rem', justifyContent: 'center', width: { xs: '80%', md: '30rem' }, marginLeft: { xs: 0, md: '5rem' } }}>
          <Fade in={checked} timeout={1000}>
            <Typography variant="h1" component="div" sx={{ fontWeight: 'bold', fontSize: { xs: '2rem', md: '3rem', lg: '5rem' } }}>
              ROCS
            </Typography>
          </Fade>
          <Fade in={checked} timeout={2000}>
            <Typography variant="body1" component="div" sx={{ fontWeight: 'bold', fontSize: { xs: '1rem', md: '1.25rem' } }}>
              La ROCS est un événement sportif d’une journée, se déroulant le samedi 21 septembre. Au programme de la journée : des tournois sportifs mélangeant les élèves de CentraleSupélec, les alumni, et le personnel de l’école, le tout dans une ambiance chaleureuse et conviviale.
            </Typography>
          </Fade>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', marginLeft: {md:4,xs:0}, marginTop: { xs: '3rem', lg: '0' } }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Slide direction="left" in={checked} timeout={1000}>
                  <Typography variant="h1" component="div" sx={{ fontWeight: 'bold', color: '#96013C', fontSize: { xs: '2rem', md: '3rem', lg: '5rem' } }}>
                    25e
                  </Typography>
                </Slide>
                <Fade in={checked} timeout={2000}>
                  <Typography variant="body1" component="div" sx={{ marginLeft: 1, fontWeight: 'bold', fontSize: { xs: '1rem', md: '1.25rem' } }}>
                    édition
                  </Typography>
                </Fade>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Slide direction="left" in={checked} timeout={1000}>
                  <Typography variant="h1" component="div" sx={{ fontWeight: 'bold', color: '#96013C', fontSize: { xs: '2rem', md: '3rem', lg: '5rem' } }}>
                    16
                  </Typography>
                </Slide>
                <Fade in={checked} timeout={2000}>
                  <Typography variant="body1" component="div" sx={{ marginLeft: 1, fontWeight: 'bold', fontSize: { xs: '1rem', md: '1.25rem' } }}>
                    sports
                  </Typography>
                </Fade>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Slide direction="left" in={checked} timeout={1000}>
                  <Typography variant="h1" component="div" sx={{ fontWeight: 'bold', color: '#96013C', fontSize: { xs: '2rem', md: '3rem', lg: '5rem' } }}>
                    500+
                  </Typography>
                </Slide>
                <Fade in={checked} timeout={2000}>
                  <Typography variant="body1" component="div" sx={{ marginLeft: 1, fontWeight: 'bold', fontSize: { xs: '1rem', md: '1.25rem' } }}>
                    participants
                  </Typography>
                </Fade>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Slide direction="left" in={checked} timeout={1000}>
                  <Typography variant="h1" component="div" sx={{ fontWeight: 'bold', color: '#96013C', fontSize: { xs: '2rem', md: '3rem', lg: '5rem' } }}>
                    1er
                  </Typography>
                </Slide>
                <Fade in={checked} timeout={2000}>
                  <Typography variant="body1" component="div" sx={{ marginLeft: 1, fontWeight: 'bold', fontSize: { xs: '1rem', md: '1.25rem' } }}>
                    événement sportif de l’année
                  </Typography>
                </Fade>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box
        id="content3"
        ref={content3Ref}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: '5rem',
          height: '200vh',
          overflowY: 'auto',
          backgroundColor: '#952f5a',
          color: '#ebe8e8',
          backgroundImage: `
            repeating-linear-gradient(to right,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0) calc(50% - 1px),
              #9f3161 calc(50% - 1px), #9f3161 calc(50% + 1px),
              rgba(0, 0, 0, 0) calc(50% + 1px), rgba(0, 0, 0, 0) 100%
            )
          `,
          backgroundSize: 'calc(100% / 5) 100%',
          padding: { xs: '2rem', md: '5rem' }
        }}
      >
        <Slide direction="left" in={checked2} timeout={1000}>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: '3rem', alignItems: 'center', justifyContent: 'space-between', marginTop: '5rem' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: { xs: '100%', md: '20rem' } }}>
              <Typography variant="h2" sx={{ fontWeight: 'bold', marginBottom: '3rem', fontSize: { xs: '1.5rem', md: '2rem', lg: '3rem' } }}>VILLAGE D'ACTI</Typography>
              <Typography sx={{ fontWeight: 'bold', fontSize: { xs: '1rem', md: '1.25rem', lg: '1rem' } }}>Tu pourras retrouver tous les participants au village ROCS pour savourer un délicieux burger et profiter des activités préparées par l’équipe BDS !</Typography>
            </Box>
            <img src={`./././villageacti2.jpg`} alt="Logo" style={{ width: '40vh', height: '40vh', objectFit: 'cover', maxWidth: '80%' }} />
          </Box>
        </Slide>

        <Slide direction="right" in={checked2} timeout={1500}>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', md: 'row' }, gap: '3rem', alignItems: 'center', justifyContent: 'center' }}>
            <img src={`./././tournoi.jpg`} alt="Logo" style={{ width: '40vh', height: '40vh', objectFit: 'cover', maxWidth: '80%' }} />
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: { xs: '100%', md: '20rem' } }}>
              <Typography variant="h2" sx={{ fontWeight: 'bold', marginBottom: '3rem', fontSize: { xs: '1.5rem', md: '2rem', lg: '3rem' } }}>TOURNOIS</Typography>
              <Typography sx={{ fontWeight: 'bold', fontSize: { xs: '1rem', md: '1.25rem', lg: '1rem' } }}>Tu peux choisir entre 16 sports pour occuper ta matinée et/ou ton après-midi. Le matin : hand, cross, volley, escalade, tennis de table, foot, rugby, golf et l’après-midi : basket, molky, tennis de table, escalade, pétanque, tennis, beach volley, badminton, spikeball et hockey sur gazon.</Typography>
            </Box>
          </Box>
        </Slide>

        <Slide direction="left" in={checked2} timeout={2000}>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: '3rem', alignItems: 'center', justifyContent: 'center' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: { xs: '100%', md: '20rem' } }}>
              <Typography variant="h2" sx={{ fontWeight: 'bold', marginBottom: '3rem', fontSize: { xs: '1.5rem', md: '2rem', lg: '3rem' } }}>RENCONTRES</Typography>
              <Typography sx={{ fontWeight: 'bold', fontSize: { xs: '1rem', md: '1.25rem', lg: '1rem' } }}>Les rencontres intergénérationnelles lors de la ROCS favorisent l'inspiration des élèves actuels par les anciens, tout en permettant aux alumni de partager leur expérience et de renforcer les liens entre centraliens !</Typography>
            </Box>
            <img src={`./././recontres.jpg`} alt="Logo" style={{ width: '40vh', height: '40vh', objectFit: 'cover', maxWidth: '80%' }} />
          </Box>
        </Slide>
      </Box>
    </Box>
  );
}

export default App;
